global.foo = "foo";
global.bar = "bar";
global.runtime = -1;
global.debugTextContent = "Debug Text (Please Ignore):";
